import { format } from "rut.js";
import { columns } from "../../../../dtos/columns";
import { CobradorMinvuDto } from "../../cobradorMinvu/models/modelsCobradorMinvu";
import { ArchivoMinvuDTO } from "../models/cobroSeguros";

export function useColumns() {

    const COLUMNS: columns<ArchivoMinvuDTO>[] = [
        {
            name: 'N° operación',
            selector: (row) =>
                row.sciNroOpe,
            sortable: true,
            sortField: 'sciNroOpe',
            wrap: true,
            export: true
        },
        {
            name: 'Rut cliente',
            selector: (row) => format(row.sciPerRut + '-' + row.sciPerDv),
            sortable: true,
            sortField: 'sciPerRut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Cliente',
            selector: (row) =>
                `${row.nombreDeudor}`,
            sortable: true,
            sortField: 'nombreDeudor',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'N° dividendo',
            selector: (row) =>
                `${row.sciNroDiv}`,
            sortable: true,
            sortField: 'sciNroDiv',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto tope prima',
            selector: (row) =>
                row.tope,
            sortable: true,
            sortField: 'tope',
            wrap: true,
            export: true,
        },

        {
            name: 'Tipo subsidio',
            selector: (row) =>
                row.codigoTipoSubsidio,
            sortable: true,
            sortField: 'codigoTipoSubsidio',
            wrap: true,
            export: true,
        },
        {
            name: 'Meses subsidio',
            selector: (row) =>
                row.meses,
            sortable: true,
            sortField: 'meses',
            wrap: true,
            export: true,
        },
    ]


    return { COLUMNS };
}